import clients from './clients';

// Local development, plus 10.0.2.2, which is the host machine as seen from the Android emulator.
const localRedirectUrl = /^https?:\/\/(localhost|10\.0\.2\.2)(:[0-9]{1,4})?$/;

export const isKnownClient = (clientId: string) =>
  Object.prototype.hasOwnProperty.call(clients, clientId);

/**
 * Whether a client may receive tokens at a redirect URL.
 *
 * Imported by the login frontend as well, which redirects without asking this service. Keep it
 * free of dependencies so both builds can bundle it.
 */
export const isAllowedRedirectUrl = (clientId: string, redirectUrl: string) =>
  isKnownClient(clientId) &&
  (clients[clientId].redirectUrls.includes(redirectUrl) ||
    localRedirectUrl.test(redirectUrl));
